import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, UntypedFormControl } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

import { GSFReport } from "../../GSF-report.service";
import { WasteReductionService } from "../service/waste-reduction.service";

@Component({
  selector: "app-waste-reduction",
  templateUrl: "./waste-reduction.component.html",
  styleUrls: ["./waste-reduction.component.css"],
})
export class WasteReductionComponent implements OnInit {
  @Input() activity;
  @Input() activityForm: UntypedFormGroup;
  @Output() errorInWasteComp: EventEmitter<string> = new EventEmitter();
  @Input() reportSubmissionId;

  imgHelpDialog = false;
  isDisplay = false;
  wasteReductionobj;
  wasteRednType: any[];
  @Input() wasteConfigJson: any;
  wasteReductionForm: UntypedFormGroup;

  constructor(
    public wasteReductionService: WasteReductionService,
    public translate: TranslateService,
    private readonly fb: UntypedFormBuilder,
    public report: GSFReport
  ) {
    this.translate = translate;
  }

  ngOnInit() {
    this.wasteReductionForm = this.fb.group({
      totalEstimatedReport: this.fb.control(0),
      tableLevelReport: this.fb.array([]),
    });
    this.loadWasteReductionData();
    this.report.gsfValid = false;
    this.errorInWasteComp.emit(this.translate.instant("PillarRestrictErrors"));
    this.onChanges();
  }

  getTranslate(key) {
    return this.translate.instant(key);
  }
  openImage() {
    this.imgHelpDialog = true;
    
  }
  closeImageModal() {
    this.imgHelpDialog = false;
  }
  getRoundOf(report) {
    return Math.round(report * 10) / 10;
  }
  loadWasteReductionData() {
    this.wasteRednType = Object.keys(this.wasteConfigJson);
    this.createFormGroup(this.wasteRednType);
  }

 
  toDisplay(){
   this.isDisplay = !this.isDisplay;
  }

  onChanges() {
    const tableFormArr = this.wasteReductionForm.get(
      "tableLevelReport"
    ) as UntypedFormArray;
    tableFormArr.valueChanges.subscribe((val) => {
      let total = 0;
      this.wasteRednType.forEach((table, ind) => {
        const tableControl = tableFormArr.controls[ind] as UntypedFormControl;
        total = total + tableControl.value;
      });
      this.wasteReductionForm
        .get("totalEstimatedReport")
        .setValue(this.getRoundOf(total));
    });
  }
  private createFormGroup(tables) {
    const tableFormArr = this.wasteReductionForm.get(
      "tableLevelReport"
    ) as UntypedFormArray;
    tables.forEach((table) => {
      tableFormArr.push(this.fb.control(0));
    });
  }
}
